@if ($data && $data.length > 0) {
  <div class="p-1 pb-sm-0 px-sm-3">
    <div class="app-just-ended-matches">
      <h2 class="app-just-ended-matches__head">
        <i class="fas fa-fire-alt"></i> {{ 'web.just_ended_matches' | translate }}
        <a (click)="close()" class="small text-reset d-inline app-category-detail-link float-right pr-2 app-cursor">
          {{ (!isClose ? 'web.close' : 'web.open') | translate }}
        </a>
        <!-- <a
        (click)="setNum(5)"
        class="small text-reset d-inline app-category-detail-link float-right pr-2 app-cursor text-super-emph2"
        [class.font-weight-bold]="num === 5"
        >
        5 &nbsp; |
      </a>
      <a
        (click)="setNum(10)"
        class="small text-reset d-inline app-category-detail-link float-right pr-2 app-cursor text-super-emph2"
        [class.font-weight-bold]="num === 10"
        >
        10</a
        > -->
      </h2>
      @if (!isClose) {
        <div
          style="position: relative; overflow: hidden"
          [ngStyle]="{ 'max-height': num * 60 + 'px' }"
          >
          @for (match of $data; track trackById($index, match)) {
            <div [@enter-leave] style="max-height: 60px">
              <app-component-match
                [match]="match"
                [sportName]="sportName"
                [detailView]="true"
                [sportId]="sportId"
                [dateFormat2]="'time'"
                >
              </app-component-match>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
